<div ngbDropdown autoClose="outside" [id]="filterElement().id">
  <button
    ngbDropdownToggle
    type="button"
    [id]="'dropdownMenuLink-' + filterElement().id"
    class="form-control"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    [title]="placeholder !== filterElement().name ? placeholder : ''"
  >
    <span>{{ placeholder }}</span>
  </button>
  <div ngbDropdownMenu aria-labelledby="'dropdownMenuLink-' + filterElement.id">
    @for (facet of filterElement().facets; track trackByFn($index, facet)) {
    <button
      ngbDropdownItem
      type="button"
      class="dropdown-item btn btn-link btn-link-action"
      [ngClass]="{ selected: facet.selected }"
      (click)="apply(facet)"
      [attr.aria-current]="facet.selected ? 'true' : undefined"
    >
      {{ facet.displayName }}
      @if (facet.count) { ({{ facet.count }}) } @if (facet.selected) {
      <fa-icon [icon]="['fas', 'check']" class="icon-checked pl-1" />
      }
    </button>
    }
  </div>
</div>
